import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import styles from "src/Assets/css/header/header.module.css";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import { Typography } from "@material-ui/core";
import { IoLocationOutline } from "react-icons/io5";
import { IoIosSearch } from "react-icons/io";
import { FaPlus } from "react-icons/fa6";
import Notifications from "src/pages/Notifications";
import profileImg from "src/Assets/images/headers/profilesvg.svg";
import homeImg from "src/Assets/images/headers/homesvg.svg";
import crownImg from "src/Assets/images/crown.png";
import bellImg from "src/Assets/images/bellIcon.png";
import filterNewIcon from "src/Assets/images/filterNewIcon.jpg";
import settingImg from "src/Assets/images/headers/settingssvg.svg";
// import logo from "src/Assets/images/skopic.png";
import logo from "src/Assets/images/skopic_grey.png";
import humberger from "src/Assets/images/humberger.svg";
import * as mapActions from "src/store/actions/mapactions/mapAction";
import { PageEnum } from "src/layout/Page";
import AskSvg from "./AskSvg";
import SaySvg from "./SaySvg";
import UpdateSvg from "./UpdateSvg";
import TagSvg from "./TagSvg";
import AnswerSvg from "./AnswerSvg";
import ReplySvg from "./ReplySvg";
import ConfirmationDialog from "../ConfirmationDialog";
import profileimageicon from "src/Assets/images/ProfileImageIcon.png";
import * as SignInActions from "../../store/actions/SignInActions/SignInAction";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import { CommunityContext } from "src/context/CommunityContext/CommunityContext.js";

const filtersDefaultState = {
  ask: true,
  say: true,
  update: true,
  tag: true,
  answer: true,
  reply: true,
};

const Header = (props) => {
  const {
    fetchSearchData,
    filterPosts,
    clearSearchHeader,
    goBack,
    isMenuActionDisabled,
    flow,
    page,
    hideSearch,
    onSkopicClick,
    pageType,
    onCommunityChange,
    changeValue,
  } = props;

  const userDetails = useSelector((state) => state.SignInReducer.userDetails);
  const settingsData = useSelector((state) => state.voteupReducer.settingsData);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(PageEnum.Home);
  const [isButtonSelect, setButtonSelect] = useState("all");
  const [isSelect, setSelect] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(false);
  const [isAllCommunitysButtonClicked, setAllCommunityButtonClicked] =
    useState(true);
  const [isPresentCommunityButtonClicked, setPresentCommunityButtonClicked] =
    useState(false);
  const [isWhiteSpace, setWhiteSpace] = useState(false);
  const [content, setContent] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [filters, setFilters] = useState({ ...filtersDefaultState });
  const [filterErrMsg, setFilterErrMsg] = useState("");
  const [modalError, setModalError] = useState("");
  const [isSuggestionVisible, setIsSuggestionVisible] = useState(false);
  const commonModalContext = useContext(CommonModalContext);
  const [showNotificationCount, setShowNotificationCount] = useState(true);
  const [showModeratorCount, setShowModeratorCount] = useState(true);
  var profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  const [notificationListPage, setNotificationListPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [searchMode, setSearchMode] = useState("keyword");
  const listRef = useRef(null);
  const bellRef = useRef(null);
  const dropdownRef = useRef(null);
  const history = useHistory();
  const communityContext = useContext(CommunityContext);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [selectedLat, setSelectedLat] = useState("");

  const [selectedLng, setSelectedLng] = useState("");

  const {
    ready,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
  });

  useEffect(() => {
    setCurrentPage(page);
  }, [page]);

  useEffect(() => {
    dispatch(SignInActions.fetchloginUser(""));
  }, []);

  useEffect(() => {
    if (clearSearchHeader) {
      setContent("");
      setSelect(false);
      setWhiteSpace(true);
    }
  }, [clearSearchHeader]);

  useEffect(() => {
    if (content.length > 0) {
      setWhiteSpace(false);
    }
  }, [content]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSelect(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onCommunitySelection = (id) => {
    if (id === "all") {
      setAllCommunityButtonClicked(!isAllCommunitysButtonClicked);
      setPresentCommunityButtonClicked(false);
    }
    if (id === "in") {
      setPresentCommunityButtonClicked(!isPresentCommunityButtonClicked);
      setAllCommunityButtonClicked(false);
    }
    setButtonSelect(id);
    // setSelect(false);
    // setWhiteSpace(true);
    console.log(isButtonSelect);
  };

  const handleScroll = useCallback(() => {
    if (!hasMore || isLoading) return; // indicates that there will be no more data
    const { scrollTop, clientHeight, scrollHeight } = listRef.current;

    if (scrollTop + clientHeight + 100 >= scrollHeight) {
      setIsLoading(true);
      setNotificationListPage((prevPage) => prevPage + 1);
    }
  }, [hasMore, isLoading]);

  const onSkopicLogoClick = async () => {
    try {
      if (onCommunityChange) {
        await onCommunityChange(
          settingsData?.userTenantId,
          settingsData?.userTenant,
        );
        filterPosts && filterPosts("");
        goBack && goBack();
      }
      console.log("settingsData:", settingsData);
    } catch (error) {
      console.error("Error in onSkopicLogoClick:", error);
    }
  };

  const homeIconClick = () => {
    setSelect(false);
    setWhiteSpace(true);
    setContent("");
    goBack && goBack();
    filterPosts && filterPosts("");
    changeValue && changeValue(0);
  };

  const addContactIconClick = () => {
    setSelect(false);
    setWhiteSpace(true);
    setShowModeratorCount(false);
    setTimeout(() => {
      setShowModeratorCount(false);
      dispatch(SignInActions.resetModeratorCount());
    }, 2000);
    //call this in mount of moderator page
    // dispatch(moderatorActions.fetchModeratingCommunityList(""));
  };

  const clearKeywordSearchState = () => {
    setContent("");
    setIsSuggestionVisible(false);
  };

  const clearLocationSearchState = () => {
    setSelectedLocation(null);
    setSelectedLat("");
    setSelectedLng("");

    clearSuggestions();
    setValue("");
  };

  const profileIconClick = () => {
    setSelect(false);
    setWhiteSpace(true);

    //TODO: Revisit this reducer
    dispatch(mapActions.fetchNearByCommunitysData("?mapStatus=IndexNear"));
  };

  const handleKeywordSearchMode = () => {
    clearKeywordSearchState();
    clearLocationSearchState();

    setSearchMode("keyword");
  };

  const handleLocationSearchMode = () => {
    clearKeywordSearchState();
    clearLocationSearchState();

    setSearchMode("location");
  };

  const settingsIconClick = () => {
    setSelect(false);
    setWhiteSpace(true);

    //TODO: Revisit this reducer
    dispatch(mapActions.fetchNearByCommunitysData("?mapStatus=IndexNear"));
  };

  const notificationIconClick = (event) => {
    event?.preventDefault?.();
    setSelect(false);
    setWhiteSpace(true);
    // setAnchorEl(event.currentTarget);
    setAnchorEl(bellRef.current);
    setNotificationListPage(1);
    setTimeout(() => {
      setShowNotificationCount(false);
      dispatch(SignInActions.resetNotificationCount());
    }, 2000);
  };

  const handleClose = () => {
    setSelect(false);
    setWhiteSpace(true);
    setAnchorEl(null);
  };

  const selectOptions = () => {
    setShowSearchIcon(!showSearchIcon);
  };

  const onClickFilter = () => {
    setSelect((prevState) => !prevState);
    setFilterErrMsg("");
    // Reset community selection to default
    setAllCommunityButtonClicked(true);
    setPresentCommunityButtonClicked(false);
    setButtonSelect("all");
  };

  const onsearch = (e, scrollType) => {
    setSelect(false);
    setWhiteSpace(true);
    e.preventDefault();
  };

  const updateFilters = (key) => {
    const copiedFilters = { ...filters };
    const prevVal = filters[key];
    copiedFilters[key] = !prevVal;
    const isAtleastOneChecked =
      copiedFilters.ask ||
      copiedFilters.say ||
      copiedFilters.update ||
      copiedFilters.tag ||
      copiedFilters.answer ||
      copiedFilters.reply;

    if (isAtleastOneChecked) {
      setFilters((prevState) => ({
        ...prevState,
        [key]: !prevState[key],
      }));
      setFilterErrMsg("");
    } else {
      setFilterErrMsg("Atleast one filter should be selected");
    }
  };

  const handleSearchKeyDown = (e, isSuggestion) => {
    if (isSuggestion || e?.key === "Enter") {
      e?.preventDefault();
      setIsSuggestionVisible(false);
      var paramsSetValue = new FormData();
      setSelect(false);
      var searchContent = content;

      if (searchMode === "keyword" && !content.trim()) {
        setModalError("Please type What you are searching for");
        return;
      }

      if (
        searchMode === "location" &&
        (!selectedLocation || !selectedLat || !selectedLng)
      ) {
        setModalError("Please select a location");
        return;
      }

      if (searchMode === "keyword") {
        paramsSetValue.append("q", searchContent);
      }

      paramsSetValue.append("comun", isButtonSelect);

      if (searchMode === "location") {
        paramsSetValue.append("cityname", selectedLocation || "");

        paramsSetValue.append("latitude", selectedLat || "");

        paramsSetValue.append("longitude", selectedLng || "");

        // Current Community Search
        if (isButtonSelect !== "all" && userDetails?.userData?.tenantId) {
          paramsSetValue.append("tenantIds", userDetails?.userData?.tenantId);
        }
      }
      if (filters.ask) paramsSetValue.append("chose", "choseask");
      if (filters.say) paramsSetValue.append("chose", "chosesay");
      if (filters.update) paramsSetValue.append("chose", "iupdate");
      if (filters.tag) paramsSetValue.append("chose", "htag");
      if (filters.answer) paramsSetValue.append("chose", "answer");
      if (filters.reply) paramsSetValue.append("chose", "reply");

      console.log("paramsSetValue", paramsSetValue);
      fetchSearchData && fetchSearchData(paramsSetValue);
      setWhiteSpace(!isWhiteSpace);
      if (searchMode === "location") {
        setSelectedLocation(null);
        setSelectedLat("");
        setSelectedLng("");
      }
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // const onClickLogo = () => {
  //   if (flow !== "beforeSignIn") {
  //     onSkopicClick && onSkopicClick();
  //     onSkopicLogoClick();
  //     changeValue && changeValue(0);
  //   }
  // };
  const onClickLogo = async () => {
    if (flow === "beforeSignIn") {
      // history.push("/");
      window.location.href = "/";
      return;
    }

    try {
      communityContext?.onChangeCommunity({
        tenantId: settingsData?.userTenantId,
        tenantName: settingsData?.userTenant,
      });

      // if (typeof onSkopicClick === "function") {
      //   onSkopicClick();
      // } else {
      //   await onSkopicLogoClick();
      // }
      if (!onSkopicClick) {
        await onSkopicLogoClick();
      }

      // Navigate AFTER logic
      history.push("/Home", {
        setCommunityToDefault: true,
      });

      changeValue && changeValue(0);
    } catch (error) {
      console.error("Error in onClickLogo:", error);
    }
  };

  const handleLocationSearch = (location, lat, lng) => {
    const paramsSetValue = new FormData();

    setIsSuggestionVisible(false);
    setSelect(false);

    paramsSetValue.append("comun", isButtonSelect);

    paramsSetValue.append("cityname", location || "");
    paramsSetValue.append("latitude", lat || "");
    paramsSetValue.append("longitude", lng || "");

    // Current Community Search
    if (isButtonSelect !== "all" && userDetails?.userData?.tenantId) {
      paramsSetValue.append("tenantIds", userDetails?.userData?.tenantId);
    }

    if (filters.ask) paramsSetValue.append("chose", "choseask");
    if (filters.say) paramsSetValue.append("chose", "chosesay");
    if (filters.update) paramsSetValue.append("chose", "iupdate");
    if (filters.tag) paramsSetValue.append("chose", "htag");
    if (filters.answer) paramsSetValue.append("chose", "answer");
    if (filters.reply) paramsSetValue.append("chose", "reply");

    fetchSearchData && fetchSearchData(paramsSetValue);

    setWhiteSpace((prev) => !prev);

    setSelectedLocation(null);
    setSelectedLat("");
    setSelectedLng("");
  };

  const handleLocationSelect = (suggestion) => async () => {
    try {
      setContent(suggestion.description);

      clearSuggestions();

      const results = await getGeocode({
        address: suggestion.description,
      });

      const { lat, lng } = await getLatLng(results[0]);

      // Extract actual city from Google Geocoder
      const addressComponents = results[0]?.address_components || [];

      const cityComponent = addressComponents.find(
        (component) =>
          component.types.includes("locality") ||
          component.types.includes("administrative_area_level_2"),
      );

      const city = cityComponent?.long_name || "";

      setSelectedLocation(suggestion.description);

      setSelectedLat(lat);

      setSelectedLng(lng);

      setIsSuggestionVisible(false);

      handleLocationSearch(city, lat, lng);

      console.log("Selected Location", {
        city: suggestion.description,
        lat,
        lng,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <nav
        // className={`navbar navbar-expand-md  navbar-light ${styles.navbarexpand}`}
        className={`navbar navbar-expand-md navbar-light ${
          styles.navbarexpand
        } ${pageType === "viewActivity" ? styles.whiteBgColor : ""}`}
      >
        <div className="container">
          <button
            className={`navbar-toggler ${styles.navbartoggler}`}
            type="button"
            data-toggle="collapse"
            data-target="#collapsibleNavbar"
          >
            <img src={humberger}></img>
          </button>
          <div>
            <div onClick={onClickLogo} role="button">
              <img
                style={{
                  cursor: "pointer",
                  objectFit: "cover",
                  width: "100px",
                  height: "38px",
                }}
                src={logo}
                alt="Skopic Logo"
              />
            </div>
          </div>

          {!hideSearch && (
            <div className={styles.whitespace}>
              <div
                style={{
                  marginRight: pageType === "viewActivity" ? "80px" : "0px",
                }}
                className={`${content.length > 0 ? styles.searchform : ""} ${
                  styles.subwhitespace
                } ${isWhiteSpace ? styles.noshowwhitespace : ""}`}
              >
                <div className={styles.searchbarmargin} ref={dropdownRef}>
                  <Input
                    id="search"
                    type="text"
                    placeholder={
                      searchMode === "location"
                        ? "Search by location"
                        : "Search with keywords"
                    }
                    className={styles.searchInput}
                    onFocus={() => setIsSuggestionVisible(true)}
                    value={content}
                    // onChange={(e) => setContent(e.target.value)}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value.length <= 280) {
                        setContent(value);

                        // Location Search Suggestions
                        if (searchMode === "location") {
                          setValue(value);
                        }
                      }
                    }}
                    onKeyDown={(e) => handleSearchKeyDown(e, false)}
                    startAdornment={
                      <InputAdornment position="start">
                        {/* Location Search */}
                        <IconButton
                          className={styles.searchIcon}
                          onClick={handleLocationSearchMode}
                        >
                          <IoLocationOutline
                            fontSize={18}
                            color={
                              searchMode === "location" ? "#373334" : "#C4C4C4"
                            }
                          />
                        </IconButton>

                        {/* Divider */}
                        <span
                          style={{
                            color: "#BDBDBD",
                            marginLeft: "2px",
                            marginRight: "2px",
                          }}
                        >
                          |
                        </span>

                        {/* Normal Search */}
                        <IconButton
                          className={styles.searchIcon}
                          onClick={handleKeywordSearchMode}
                        >
                          <IoIosSearch
                            fontSize={18}
                            color={
                              searchMode === "keyword" ? "#373334" : "#C4C4C4"
                            }
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={onClickFilter}
                          className={styles.plusIcon}
                          style={{ padding: "6px" }}
                        >
                          {/* <FaPlus fontSize={16} color="#a6a6a6" /> */}
                          <img
                            src={filterNewIcon}
                            alt="filter"
                            style={{ height: "15px", color: "#a6a6a6" }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                    sx={{
                      "& .MuiInputBase-input::placeholder": {
                        fontSize: "14px",
                      },
                      "& .MuiInputBase-input": {
                        padding: "4px",
                        fontWeight: "normal",
                        fontSize: "14px",
                      },
                    }}
                  />
                  {searchMode === "keyword" &&
                    content.length > 0 &&
                    isSuggestionVisible && (
                      <div
                        style={{
                          position: "absolute",
                          top: "44px",
                          borderRadius: "8px",
                          padding: "10px",
                          wordBreak: "break-all",
                          maxHeight: "100px",
                          width: "288px",
                          overflowY: "scroll",
                          backgroundColor: "white",
                          cursor: "pointer",
                          zIndex: 1,
                        }}
                        onClick={() => handleSearchKeyDown(null, true)}
                      >
                        <IconButton className={styles.searchIconNew}>
                          <IoIosSearch fontSize={20} />
                        </IconButton>
                        <b>{content}</b>
                      </div>
                    )}
                  {searchMode === "location" &&
                    status === "OK" &&
                    data.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "44px",
                          width: "288px",
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                          zIndex: 10,
                          maxHeight: "200px",
                          overflowY: "auto",
                          boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                        }}
                      >
                        {data.map((suggestion) => (
                          <div
                            key={suggestion.place_id}
                            style={{
                              padding: "10px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                            onClick={handleLocationSelect(suggestion)}
                          >
                            <IoLocationOutline
                              style={{
                                marginRight: "8px",
                              }}
                            />
                            {suggestion.description}
                          </div>
                        ))}
                      </div>
                    )}
                  <div
                    className={`${styles.searchdropdown} ${
                      isSelect && styles.searchoptions
                    }`}
                  >
                    <div>
                      <button
                        id="AllCommunitys"
                        className={`${styles.allcommunitys} ${
                          isAllCommunitysButtonClicked
                            ? styles.buttonselectionstyle
                            : ""
                        }`}
                        onClick={() => onCommunitySelection("all")}
                      >
                        All Communities
                      </button>
                      <button
                        id="presentcommunity"
                        className={`${styles.thiscommunity} ${
                          isPresentCommunityButtonClicked
                            ? styles.buttonselectionstyle
                            : ""
                        }`}
                        onClick={() => onCommunitySelection("in")}
                      >
                        This Community
                      </button>
                    </div>
                    <table className={styles.filteroptions}>
                      <tbody>
                        <tr>
                          <td>
                            <span>
                              <input
                                type="checkbox"
                                className={styles.filtercheckboxes}
                                name="choseask"
                                id="choseask"
                                checked={filters.ask}
                                onChange={() => updateFilters("ask")}
                              />{" "}
                              <AskSvg />
                            </span>
                          </td>
                          <td>
                            <span>
                              <input
                                type="checkbox"
                                className={styles.filtercheckboxes}
                                name="chosesay"
                                id="chosesay"
                                checked={filters.say}
                                onChange={() => updateFilters("say")}
                              />
                              <SaySvg />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              <input
                                type="checkbox"
                                className={styles.filtercheckboxes}
                                name="iupdate"
                                id="iupdate"
                                checked={filters.update}
                                onChange={() => updateFilters("update")}
                              />
                              <UpdateSvg />
                            </span>
                          </td>
                          <td>
                            <span>
                              <input
                                type="checkbox"
                                className={styles.filtercheckboxes}
                                name="htag"
                                id="htag"
                                checked={filters.tag}
                                onChange={() => updateFilters("tag")}
                              />
                              <TagSvg />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>
                              <input
                                type="checkbox"
                                className={styles.filtercheckboxes}
                                name="ianswer"
                                id="ianswer"
                                checked={filters.answer}
                                onChange={() => updateFilters("answer")}
                              />
                              <AnswerSvg />
                            </span>
                          </td>
                          <td>
                            <span>
                              <input
                                type="checkbox"
                                className={styles.filtercheckboxes}
                                name="ireply"
                                id="ireply"
                                checked={filters.reply}
                                onChange={() => updateFilters("reply")}
                              />
                              <ReplySvg />
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {filterErrMsg && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "6px",
                          marginBottom: 0,
                        }}
                      >
                        <Typography
                          style={{ marginTop: 0, marginBlockStart: 0 }}
                          color="error"
                          variant="caption"
                        >
                          {filterErrMsg}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!isMenuActionDisabled && (
            <div
              className={`collapse navbar-collapse ${styles.collapse}`}
              id="collapsibleNavbar"
              style={{ flexDirection: "row-reverse" }}
            >
              <ul className={`navbar-nav ${styles.navbarnav}`}>
                <li className="nav-item">
                  <div className={styles.iconadjust}>
                    <Link
                      className={`${styles.iconbuttons} ${
                        currentPage === PageEnum.Profile && !open
                          ? styles.iconbuttonsactive
                          : ""
                      }`}
                      onClick={profileIconClick}
                      to="/activity"
                      role="button"
                      style={{ padding: 0 }}
                    >
                      {userDetails &&
                      Object.keys(userDetails.userData || {}).length > 0 ? (
                        <img
                          src={`${profileImagePath}${userDetails?.userData?.uimage}`}
                          className={styles.headerProfileImg}
                          alt="User Profile"
                        />
                      ) : (
                        <img
                          src={process.env.REACT_APP_DUMMY_PROFILE_IMAGE}
                          className={styles.headerProfileImg}
                          alt="Default Profile Icon"
                        />
                      )}

                      <p>Me</p>
                    </Link>
                  </div>
                </li>
                <li className="nav-item">
                  <div className={styles.iconadjust}>
                    <Link
                      className={`${styles.iconbuttons} ${
                        currentPage === PageEnum.Home && !open
                          ? styles.iconbuttonsactive
                          : ""
                      }`}
                      role="button"
                      to={{
                        pathname: "/Home",
                        state: {
                          setCommunityToDefault: false,
                        },
                      }}
                      onClick={homeIconClick}
                    >
                      <img
                        src={homeImg}
                        className={styles.headerHomeImg}
                        alt="home"
                      />
                      <p>Home</p>
                    </Link>
                  </div>
                </li>
                {userDetails && Object.keys(userDetails).length !== 0 ? (
                  userDetails.userData.isModerator === "1" ||
                  userDetails.userData.isAdmin === "1" ? (
                    <li className="nav-item">
                      <div className={styles.iconadjust}>
                        <Link
                          role="button"
                          className={`${styles.iconbuttons} ${
                            currentPage === PageEnum.Moderator && !open
                              ? styles.iconbuttonsactive
                              : ""
                          }`}
                          onClick={addContactIconClick}
                          to="/Moderator"
                        >
                          <div className={styles.iconContainer}>
                            <img
                              src={crownImg}
                              className={styles.headerImg}
                              alt="moderator"
                            />
                            {showModeratorCount &&
                              userDetails?.userData
                                ?.moderatorActionItemsViewStatus > 0 && (
                                <div
                                  className={`${styles.moderatorCountBadge} ${
                                    userDetails.userData
                                      .moderatorActionItemsViewStatus > 99
                                      ? styles.longCount
                                      : ""
                                  }`}
                                >
                                  {userDetails.userData
                                    .moderatorActionItemsViewStatus > 99
                                    ? "99+"
                                    : userDetails.userData
                                        .moderatorActionItemsViewStatus}
                                </div>
                              )}
                          </div>
                          <p>Moderator</p>
                        </Link>
                      </div>
                    </li>
                  ) : null
                ) : null}
                <li className="nav-item">
                  <>
                    <div className={styles.iconadjust}>
                      <a
                        ref={bellRef}
                        className={`${styles.iconbuttons} ${
                          open === true ? styles.iconbuttonsactive : ""
                        }`}
                        onClick={notificationIconClick}
                        href="#notifications"
                        role="button"
                      >
                        {/* <img
                          src={bellImg}
                          className={styles.headerImg}
                          alt="Notification"
                        /> */}
                        <div className={styles.iconContainer}>
                          <img
                            src={bellImg}
                            className={styles.headerImg}
                            alt="Notification"
                          />
                          {showNotificationCount &&
                            userDetails?.userData?.notificatinCount > 0 && (
                              <div
                                className={`${styles.notificationBadge} ${
                                  userDetails.userData.notificatinCount > 99
                                    ? styles.longCount
                                    : ""
                                }`}
                              >
                                {userDetails.userData.notificatinCount > 99
                                  ? "99+"
                                  : userDetails.userData.notificatinCount}
                              </div>
                            )}
                        </div>
                        <p>Notifications</p>
                      </a>
                    </div>
                    <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      sx={{
                        "& .MuiPopover-paper": {
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <div
                        className={styles.notificationWrapper}
                        ref={listRef}
                        onScroll={handleScroll}
                      >
                        <Notifications
                          notificationListPage={notificationListPage}
                          setNotificationListPage={setNotificationListPage}
                          setIsNotificationLoading={setIsLoading}
                          setHasMoreNotifications={setHasMore}
                        />
                      </div>
                    </Popover>
                  </>
                </li>
                <li className="nav-item">
                  <div className={styles.iconadjust}>
                    <Link
                      className={`${styles.iconbuttons} ${
                        currentPage === PageEnum.Settings && !open
                          ? styles.iconbuttonsactive
                          : ""
                      }`}
                      onClick={settingsIconClick}
                      to="/Settings"
                      role="button"
                    >
                      <img
                        src={settingImg}
                        className={styles.headerImg}
                        alt="settings"
                      />
                      <p>Settings</p>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>
      {modalError && (
        <ConfirmationDialog
          open={true}
          handleClose={() => setModalError("")}
          type={"warning"}
          title={modalError}
          acceptLabel={"Ok"}
          onAccept={() => setModalError("")}
        />
      )}
    </React.Fragment>
  );
};

export default Header;
